/**
 * Parses a comma- or newline-separated string of mpvId values into a
 * deduplicated, trimmed array. Preserves original casing — case-normalisation
 * for catalog lookups happens in the calling component.
 */
export const parseCsvToMpvIds = (csv: string): string[] => {
  const tokens = csv.split(/[,\n]/);
  const trimmed = tokens.map((token) => token.trim()).filter((token) => token.length > 0);
  return [...new Set(trimmed)];
};
